import { apiAuth, apiResponseType } from ".";

/** Alertas de % de estoque (LOT-26) */

export type StockAlertLevel = "warning" | "danger";

export interface StockAlert {
  uuid: string;
  threshold: number;
  level: StockAlertLevel;
  /** product = um produto do concurso; contest = estoque final do concurso */
  scope: "product" | "contest";
  available_percent: number;
  available_quantity: number;
  created_quantity: number;
  created_at: string;
  contest_id: number;
  contest_name: string;
  validation_date: string;
  lottery_name: string;
  lottery_color: string | null;
  product_classification_id: number | null;
  product_name: string | null;
}

export const getPendingStockAlerts = (): apiResponseType =>
  apiAuth.get("stock-alerts/pending") as apiResponseType;

export const acknowledgeStockAlert = (uuid: string): apiResponseType =>
  apiAuth.post(`stock-alerts/${uuid}/acknowledge`) as apiResponseType;
